import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components/macro'

import { EmptyState } from '@loadsmart/loadsmart-ui'

import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { screen } from 'legacy/styles/screen'

const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-height: 240px;
    height: auto !important;
  }

  ${screen.md} {
    img {
      height: 240px !important;
    }
  }
`

function NoOffersMessage({ filtersQuery, onResetClick, entity }) {
  const history = useHistory()

  const isFiltering = Object.keys(filtersQuery).length !== 0
  const isPreferredLanesFilter = filtersQuery.filterByPreferredLanes === 'true'

  if (isPreferredLanesFilter) {
    return (
      <Content>
        <EmptyState
          variant="page"
          illustration={IllustrationDepartingTruck}
          title="No loads found"
          description="Go to preferred lanes page to manage your favorites and find more matches"
          action={{
            label: 'Manage preferred lanes',
            onClick: () => history.push('/preferred-lanes'),
          }}
        />
      </Content>
    )
  }

  if (isFiltering) {
    return (
      <Content>
        <EmptyState
          variant="page"
          illustration={IllustrationDepartingTruck}
          title="Your search did not match any loads"
          description="Try a different combination of filters"
          action={{
            label: 'Reset filters',
            onClick: onResetClick,
          }}
        />
      </Content>
    )
  }

  if (entity === 'broker') {
    return (
      <Content>
        <EmptyState
          variant="page"
          illustration={<img src={IllustrationDepartingTruck} alt="" />}
          title="You don't have any more pending invites or tenders"
          description="Check back once you receive other loads from your shippers..."
        />
      </Content>
    )
  }

  return (
    <Content>
      <EmptyState
        variant="page"
        illustration={IllustrationDepartingTruck}
        title="We are looking for new available loads"
        description="Check back in a few minutes..."
      />
    </Content>
  )
}

NoOffersMessage.propTypes = {
  onResetClick: PropTypes.func,
  filtersQuery: PropTypes.shape({}),
  entity: PropTypes.oneOf(['carrier', 'broker']),
}

NoOffersMessage.defaultProps = {
  onResetClick: Function.prototype,
  filtersQuery: {},
  entity: 'carrier',
}

export { NoOffersMessage }
